import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ValuesList } from '../../../UI/ValuesList/ValuesList';
import { useTranslation } from 'react-i18next';

export const EstimateMeasurementWindow = () => {
    const { manualCalculations } = useSelector((state) => state.measurementsReducer);

    const { t } = useTranslation();

    const values = useMemo(() => {
        const windowValues = [
            {
                title: t('EstimateMeasurementWindow.values.title.window_quantity'),
                type: 'window_quantity',
                value: manualCalculations.window_quantity,
                unit: t('MeasurementDoors.unit.quantity'),
            },
            {
                title: t('EstimateMeasurementWindow.values.title.window_area'),
                type: 'window_area',
                value: manualCalculations.window_area,
                unit: t('MeasurementDoors.unit.area'),
            },
            {
                title: t('EstimateMeasurementWindow.values.title.window_perimeter'),
                type: 'window_perimeter',
                value: manualCalculations.window_perimeter,
                unit: t('MeasurementDoors.unit.perimeter'),
            },
            {
                title: t('EstimateMeasurementWindow.values.title.window_slope_area'),
                type: 'window_slope_area',
                value: manualCalculations.window_slope_area,
                unit: t('MeasurementDoors.unit.slope_area'),
            },
            {
                title: t('EstimateMeasurementWindow.values.title.window_slope_perimeter'),
                type: 'window_slope_perimeter',
                value: manualCalculations.window_slope_perimeter,
                unit: t('MeasurementDoors.unit.slope_perimeter'),
            },
        ];

        const hasValues = windowValues.some((windowValue) => parseInt(windowValue.value, 10) > 0);
        return hasValues ? windowValues : [];
    }, [
        manualCalculations.window_area,
        manualCalculations.window_perimeter,
        manualCalculations.window_quantity,
        manualCalculations.window_slope_area,
        manualCalculations.window_slope_perimeter,
    ]);

    return (
        <>
            {!!values.length && (
                <ValuesList
                    title={t('EstimateMeasurementWindow.return.ValuesList.title')}
                    values={values}
                />
            )}
        </>
    );
};
